import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export type MappingMode = 'add' | 'edit';

export function ModeToggle({
    mode,
    onChange,
    idPrefix,
}: {
    mode: MappingMode;
    onChange: (mode: MappingMode) => void;
    idPrefix: string;
}) {
    const { t } = useTranslation();
    return (
        <ToggleButtonGroup
            type="radio"
            name={`${idPrefix}-mode`}
            value={mode}
            onChange={(v) => onChange(v as MappingMode)}
            className="mb-3"
        >
            <ToggleButton id={`${idPrefix}-add`} value="add" variant="outline-primary">
                {t('mappings.modeAdd')}
            </ToggleButton>
            <ToggleButton id={`${idPrefix}-edit`} value="edit" variant="outline-primary">
                {t('mappings.modeEdit')}
            </ToggleButton>
        </ToggleButtonGroup>
    );
}
